import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { Wheat, ArrowLeft } from 'lucide-react';

export default function RecuperarSenhaDash() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.userMessage || 'Erro ao enviar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-bg flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <Link to="/admin/login" className="flex items-center gap-2 text-brand-text-muted mb-6 text-sm font-body hover:text-brand-text">
          <ArrowLeft className="w-4 h-4" /> Voltar ao login
        </Link>
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-brand-border">
          <h2 className="font-dashboard font-bold text-brand-text mb-2">Recuperar Senha</h2>
          {!sent ? (
            <>
              <p className="text-sm text-brand-text-muted font-body mb-4">Digite seu e-mail para receber as instruções.</p>
              {error && <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-xl px-4 py-3 mb-4">{error}</div>}
              <form onSubmit={handleSubmit} className="space-y-4">
                <input type="email" className="w-full rounded-lg border border-brand-border px-3 py-2.5 text-sm font-body focus:outline-none focus:ring-2 focus:ring-brand-accent-mid" placeholder="seu@email.com" value={email} onChange={e => setEmail(e.target.value)} required />
                <button type="submit" disabled={loading} className="w-full py-2.5 rounded-lg btn-primary font-dashboard font-semibold text-sm">{loading ? 'Enviando...' : 'Enviar Instruções'}</button>
              </form>
            </>
          ) : (
            <p className="text-sm text-brand-text-muted font-body">Se o e-mail existir, você receberá as instruções em breve.</p>
          )}
        </div>
      </div>
    </div>
  );
}
